import { set, toggle } from '@/utils/vuex'

export default {
  setDrawer: set('drawer'),
  setImage: set('image'),
  setColor: set('color'),
  toggleMini: toggle('mini'),
  toggleDrawer: toggle('drawer'),
  setBreadcrumbs: set('breadcrumbs'),
}
